import LoginPage from "../pages/LoginPage";
import { useAuth } from "./AuthContext";



interface ProtectedRouteProps {
    element: React.ReactNode;
    requiredRoles?: string[];
}

const ProtectedRoute = ({ element, requiredRoles }: ProtectedRouteProps) => {
    const { isAuthenticated } = useAuth();

    console.log(isAuthenticated)
    // If not authenticated, redirect to login page
    if (!isAuthenticated) {
        console.log(isAuthenticated)
        return <LoginPage />;
    }

    // If authenticated but role doesn't match required role, redirect to home
    // if (!requiredRoles.includes(role!)) {
    //     return <LoginPage />;
    // }

    return <>{element}</>;
};

export default ProtectedRoute;
